import React from 'react';
import { Alert as HeroAlert, Button } from '@heroui/react';

export interface AlertProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string | React.ReactNode;
  content?: React.ReactNode;
  variant?: 'flat' | 'solid' | 'bordered' | 'faded';
  color?: 'primary' | 'danger' | 'success' | 'warning';
  hideIcon?: boolean;
  radius?: 'sm' | 'md' | 'lg' | string;
  visible?: boolean;
  onClose?: () => void;
  action?: {
    label: string;
    onClick: () => void;
  };
  className?: string;
  fullWidth?: boolean;
  isClosable?: boolean;
  hideIconWrapper?: boolean;
}

const Alert: React.FC<AlertProps> = ({
  title,
  content,
  variant = 'flat',
  color = 'primary',
  hideIcon = false,
  radius = 'lg',
  visible = true,
  onClose,
  action,
  className = '',
  fullWidth = true,
  isClosable,
  hideIconWrapper = false,
  ...rest
}) => {
  if (!visible) return null;

  return (
    <HeroAlert
      variant={variant}
      color={color}
      hideIcon={hideIcon}
      hideIconWrapper={hideIconWrapper}
      isClosable={isClosable}
      onClose={onClose}
      className={`rounded-${radius} ${fullWidth ? 'w-full' : ''} ${className}`}
      endContent={
        action ? (
          <Button size="sm" color={color} onClick={action.onClick}>
            {action.label}
          </Button>
        ) : null
      }
      {...rest}
    >
      <div className="font-semibold">{title}</div>
      {content && <div className="text-sm mt-1">{content}</div>}
    </HeroAlert>
  );
};

export default Alert;
